"use strict";
exports.__esModule = true;
function checkFunction(obj) {
    if (!(obj instanceof Function)) {
        throw new Error('callback should be a valid function');
    }
}
exports.checkFunction = checkFunction;
function clearQueryParams(url) {
    return url.replace(/\?((\w)+(=(\w)+&?)?)+/, '');
}
exports.clearQueryParams = clearQueryParams;
function addQueryParamParts(urlParts, queryParamsObj) {
    var id = 0;
    urlParts = [].concat(urlParts);
    urlParts.push('?');
    for (var key in queryParamsObj) {
        var value = queryParamsObj[key];
        //optional check for properties from prototype chain
        if (queryParamsObj.hasOwnProperty(key)) {
            if (id !== 0) {
                urlParts.push('&');
            }
            if (Array.isArray(value)) {
                for (var i = 0; i < value.length; i++) {
                    if (i !== 0) {
                        urlParts.push('&');
                    }
                    urlParts.push(key);
                    urlParts.push('=');
                    urlParts.push(value[i]);
                }
            }
            else {
                urlParts.push(key);
                if (value || value === 0) {
                    urlParts.push('=');
                    urlParts.push(value);
                }
            }
            id++;
        }
    }
    return urlParts;
}
exports.addQueryParamParts = addQueryParamParts;
//# sourceMappingURL=tools.js.map